import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../components/header/DashboardHeader";
import "./Groups.css";
import { Link, useSearchParams } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { groupListingApi } from "../../../services/groups";
import { groupType } from "../../../utils/staticData";
import { tabHandler } from "../../../utils/regexValidation";
import MyGroup from "./groupSubModules/MyGroup";
import JoinedGroup from "./groupSubModules/JoinedGroup";
import ExploreGroup from "./groupSubModules/ExploreGroup";
import useDebounce from "../../../hooks/useDebounce";
import FavouriteGroup from "./groupSubModules/FavouriteGroup";
import { toastMessage } from "../../../utils/toastMessage";
import { MdAdd } from "react-icons/md";
 
const Groups = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const debouncedValue = useDebounce(search, 300);
  let type = searchParam.get("type") || "";
  const [groupList, setGroupList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exploreSearch, setExploreSearch] = useState("");
  const [favoriteSearch, setFavoriteSearch] = useState("");
  const [hasMore, setHasMore] = useState(true);
 
  //--------search-handler-----------
  const searchHandler = (e, type) => {
    const { value } = e.target;
    if (type === "explore") {
      setExploreSearch(value);
    }
    if (type === "favourite") {
      setFavoriteSearch(value);
    } else {
      setSearch(value);
    }
  };
 
  //--------------listing-API-------------------
  const fetchingGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true);
      const { data } = await groupListingApi({
        type: type,
        pagination: "true",
        search: debouncedValue,
        limit: 12,
        page,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 12);
      } else {
        toastMessage(message, "error", "groupList");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchingGroupListHandler(1, true);
  }, [debouncedValue, type]);
 
  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      fetchingGroupListHandler(nextPage);
      return nextPage;
    });
  };
  //-------when-change-tab------------
  useEffect(() => {
    setPage(1);
    setSearch("");
    setExploreSearch("");
    setFavoriteSearch("");
  }, [type]);
 
  return (
    <>
      {/* Group_Header_Start */}
      <DashboardHeader title={"Groups"} />
      <div className="dashboard_pages">
        <div className="GroupPage">
          <div className="grp_Navbar">
            <div className="tab_button_wrap">
              <ul>
                {groupType?.map((data, ind) => (
                  <li key={ind}>
                    <button
                      type="button"
                      onClick={() =>
                        tabHandler(
                          "type",
                          data?.value,
                          searchParam,
                          setSearchParam
                        )
                      }
                      className={type === data?.value ? "active" : ""}
                    >
                      {data?.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="search_button_wrap">
              <div className="search_bar">
                <CiSearch />
                <input
                  type="text"
                  className="search_input"
                  placeholder="Search here"
                  value={search || favoriteSearch || exploreSearch}
                  onChange={(e) => searchHandler(e, type)}
                />
              </div>
 
              {type === "" && (
                <Link
                  to="/dashboard/group/create-group"
                  className="button has_add_icon"
                >
                  Create Group <MdAdd />
                </Link>
              )}
            </div>
          </div>
 
          {type === "favourite" && <FavouriteGroup {...{ favoriteSearch }} />}
 
          {type === "" && (
            <MyGroup
              {...{ groupList, fetchMoreData, hasMore, setGroupList, loading }}
            />
          )}
 
          {type === "joined" && (
            <JoinedGroup
              {...{ groupList, fetchMoreData, hasMore, setGroupList, loading }}
            />
          )}
 
          {type === "explore" && <ExploreGroup {...{ exploreSearch }} />}
        </div>
      </div>
    </>
  );
};
 
export default Groups;